import {useState } from 'react';

// material-ui
import { Theme } from '@mui/material/styles';
import { Box, Stack, Grid2, OutlinedInput, Button, Container, IconButton } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

import Profile from 'layout/MainLayout/Header/HeaderContent/Profile';
import Notification from 'layout/MainLayout/Header/HeaderContent/Notification';
import MobileSection from 'layout/MainLayout/Header/HeaderContent/MobileSection';


import Logo from 'components/logo';

import useAuth from 'hooks/useAuth';
import HeaderOption from './HeaderOption2';

import WishList from 'layout/MainLayout/Header/HeaderContent/wishList';
import { Magicpen, SearchNormal1, CloseCircle } from 'iconsax-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { dispatch } from 'store';
import { setLernerSearch } from 'store/reducers/courseSlice';


// ==============================|| HEADER - CONTENT ||============================== //

const StudentHeaderContent = ({
  hideDrawer,
  isStudent,
  handleAiChat
}: {
  hideDrawer: boolean;
  isStudent: boolean;
  handleAiChat?: () => void;
}) => {

  const location = useLocation();
  const ifInQuiz = location.pathname === '/learner/quiz/test';
  const ifInExams = location.pathname === '/learner/test';
  const aboveLG = useMediaQuery((theme: Theme) => theme.breakpoints.up(1620));
  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down(1220));
  const down842SM = useMediaQuery((theme: Theme) => theme.breakpoints.down(842));
  const downSM = useMediaQuery((theme: Theme) => theme.breakpoints.down(526));
  const downMD = useMediaQuery((theme: Theme) => theme.breakpoints.down(1024));
  const [hover, setHover] = useState(false);




  // eslint-disable-next-line react-hooks/exhaustive-deps


  const { user } = useAuth();
  const permission = user?.userTypeId?.permission;
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState('');
 

  const handleKeyPress = (event: any) => {
    if (event.key === 'Enter') {
      dispatch(setLernerSearch(searchText));
      if (location.pathname !== '/learner/course' && searchText !== '') {
        navigate('/learner/course', { state: { searchText: searchText } });
      }
    }
  };

  const handleClearSearch = () => {
    setSearchText('');
    dispatch(setLernerSearch(''));
  };

  let boxPadding;
  if(aboveLG){
    boxPadding = 0;
  }
  else if(downSM){
    boxPadding = '12px'
  }
  else {
    boxPadding = '24px'
  } 

  return (
    <Container disableGutters sx={{ maxWidth: '1600px !important' }}>
      <Grid2 container direction="column">
        <Grid2 >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              backgroundColor: '#063B9A',
              width: '100%',
              px: boxPadding,
              py: downLG ? 1.5 : 0,
            
              pointerEvents: ifInQuiz || ifInExams ? 'none' : 'auto'
            }}
          >
            <Box className="logo-welcome">{hideDrawer && <Logo to={'/learner'} />}</Box>
         

            {!downLG && (
              <Box sx={{ pt: 1.5 }}>
                <HeaderOption />
              </Box>
            )}
         
            {/* {!downSM && permission?.AIChat?.View && (
              <>
                <style>
                  {`
                    @property --rotate {
                      syntax: '<angle>';
                      initial-value: 100.47deg;
                      inherits: false;
                    }

                    @keyframes rotate-gradient {
                      from {
                        --rotate: 100.47deg;
                      }
                      to {
                        --rotate: 460.47deg;
                      }
                    }

                    .gradient-button {
                      font-family: 'Poppins', sans-serif;
                      width: ${downMD ? '92px' : '112px'};
                      height: 45px;
                      border: 1px solid #D1D1D1;
                      color: #fff;
                      border-radius: 12px;
                      font-weight: 500;
                      cursor: pointer;
                      background-image: linear-gradient(var(--rotate), #D446E1 1.88%, #EA5353 96.17%);
                      transition: all 0.3s ease;
                    }

                    .gradient-button.hover {
                      color: #fff;
                      animation: rotate-gradient 1.5s cubic-bezier(0.37, 0.32, 0, 1);
                      boxShadow: 0px 4px 10px rgba(0, 0, 0, 0.15)
                    }
                  `}
                </style>
                <Button
                  startIcon={<Magicpen />}
                  className={`gradient-button ${hover ? 'hover' : ''}`}
                  onClick={handleAiChat}
                  onMouseEnter={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
                >
                  {' '}
                  Ask AI
                </Button>
              </>
            )} */}
            {permission?.UserCourses?.View && <Box sx={{ display: down842SM ? 'none' : 'block', pr: 2 }} className="search-box">
              <OutlinedInput
                startAdornment={<SearchNormal1 />}
                endAdornment={
                  searchText && (
                    <IconButton
                      size="small"
                      onClick={handleClearSearch}
                      sx={{
                        padding: '4px',
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)'
                        }
                      }}
                    >
                      <CloseCircle size="20" color="#666" />
                    </IconButton>
                  )
                }
                placeholder="Search Courses..."
                value={searchText}
                onChange={(e) => {
                  setSearchText(e.target.value);
                  if (e.target.value === '') {
                    dispatch(setLernerSearch(e.target.value));
                  }
                }}
                onKeyDown={handleKeyPress}
            
                sx={{
                  width: { sm: 'auto' },
                  minHeight: '46px',
                  ml: 2,
                  borderRadius: '12px',
                  backgroundColor: 'white',
                  '& input::placeholder': {
                    color: '#9E9E9E'
                  }
                }}
              />
            </Box>}
            <Stack display="flex" direction="row" alignItems="center" spacing={2} sx={{ ml: downSM ? 1 : 0 }}>
              {!downMD && user?.type !== 'superadmin' && permission?.Courses?.View && permission?.UserCourses?.View && <WishList />}
        
              {permission?.EventNotification?.View && < Notification />}


              {user && (<><Box className="profile-control" sx={{ overflow: 'hidden', ml: downSM ? '8px !important' : 2, pr: downSM ? 0 : 1 }}>
                <Profile />
              </Box>
              <MobileSection isStudent={isStudent} /></>)}
            </Stack>
          </Box>
        </Grid2>

      </Grid2>
    </Container>
  );
};

export default StudentHeaderContent;
